import React from "react";

import Box from "@material-ui/core/Box";

const ZoneColor = (props) => {
  const { color } = props;

  return (
    <Box
      style={{
        backgroundColor: `#${color}`,
        width: "60px",
        height: "30px",
      }}
    />
  );
};

export default ZoneColor;
